import { createAction } from "redux-actions";

export enum ERROR_ACTIONS {
  SET_ERROR = "ERROR/SET_ERROR",
  SET_SHOW_STATUS = "ERROR/SET_SHOW_STATUS",
  CLEAR_ERROR = "ERROR/CLEAR_ERROR",
}

export const setError = createAction(ERROR_ACTIONS.SET_ERROR);
export const setShowStatus = createAction(ERROR_ACTIONS.SET_SHOW_STATUS);
export const clearError = createAction(ERROR_ACTIONS.CLEAR_ERROR);
